import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import { purchaseStatus } from './productPresentation';

const COLORS = {
  available: 'text-green-800',
  preorder: 'text-amber-800',
  supplier: 'text-amber-800',
  drop: 'text-purple-800',
  auction: 'text-teal-800',
  unavailable: 'text-gray-600',
};

export default function ProductStockBadge({ purchase, product }) {
  const { t } = useTranslation('product');
  const status = purchaseStatus(purchase, product);
  return <span className={`inline-flex items-center gap-2 text-xs font-bold ${COLORS[status] || COLORS.unavailable}`}>
    <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-current" />{t(`status.${status}`)}
  </span>;
}
